import { Component, Input, OnInit } from '@angular/core';
import { SsoUserDto } from '../dto/sso-user.dto';
import { UserApiService } from '../services/user-api.service';
import { directionsAT } from '../directions';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false
})
export class FooterComponent implements OnInit {

  @Input() translation: any;
  @Input() userData: SsoUserDto | undefined;

  personalFooter = '';
  contractFooter = '';
  securityFooter = '';

  myDirectManager: {
    cn: string,
    displayName: string,
    sn: string,
    givenName: string,
    mail: string,
    careerTitle: string,
  } | undefined;

  constructor(
    private userApiService: UserApiService
  ) { }

  ngOnInit(): void {

    this.userApiService.getMyDirectManager().subscribe({
      next: (directManager) => {
        if (directManager) {
          this.myDirectManager = directManager;
          this.getContractFooter();
        }
      },
      error: (error) => {
        console.error(error);
      }
    });

    if (this.userData!.country === 'HU' || this.userData!.preferredLanguage === 'hungarian') {
      this.personalFooter = `
            <p>+36 70 386 3659<br><a href="mailto:regisztracio@efs-zrt.hu">regisztracio@efs-zrt.hu</a></p>
            <p class="mt-3"><strong>Hozzáférhetőség:</strong><br>Hétfő-Péntek: 08:00-16:30</p>
          `;
    } else {
      this.personalFooter = `<p>+49 6131 58388-95<br><a href="mailto:personalabteilung@efs-ag.de">personalabteilung@efs-ag.de</a></p>
      <p><a href="https://files.efs-ag.services/EFS-IT-Personal.vcf">Telefonbuchkontakt</a></p>`;
    }

    if (this.userData!.country === 'AT' || this.userData!.preferredLanguage === 'austria') {
      this.contractFooter = `<p><strong>Antragsabteilung Österreich:</strong></p>
            <p>+49 6131 58388-54<br><a href="mailto:antrag-at@efs-ag.de">antrag-at@efs-ag.de</a></p>
            <p><a href="https://files.efs-ag.services/EFS-Antragsabteilung-AT.vcf">Telefonbuchkontakt</a></p>`;

          this.securityFooter = `<p><strong>Wertpapierabteilung:</strong></p>
            <p>+49 6131 58388-54<br><a href="mailto:wertpapier-antraege@efs-ag.de">wertpapier-antraege@efs-ag.de</a></p>
            <p><a href="https://files.efs-ag.services/EFS-Wertpapierabteilung.vcf">Telefonbuchkontakt</a></p>
          `;
    }

    if (this.userData!.country === 'DE' || this.userData!.preferredLanguage === 'german') {
      this.contractFooter = `
            <p><strong>Antragsabteilung Deutschland:</strong></p>
            <p>+49 6131 5838-50<br><a href="mailto:antrag@efs-ag.de">antrag@efs-ag.de</a></p>
            <p><a href="https://files.efs-ag.services/EFS-Antragsabteilung-DE.vcf">Telefonbuchkontakt</a></p> 
          `;
    }

    if (this.userData!.country === 'HU' || this.userData!.preferredLanguage === 'hungarian') {
      this.contractFooter = `
            <p><strong>Antrags érintkezés:</strong></p>
            <p>+36 70 945 1624<br><a href="mailto:office@efs-zrt.hu">office@efs-zrt.hu</a></p>
            <p class="mt-3"><strong>Hozzáférhetőség:</strong><br>Hétfő-Péntek: 08:00-16:30</p>
            <p><a href="https://files.efs-ag.services/EFS-Antragsabteilung-HU.vcf">Telefonbuchkontakt</a></p>
          `;
    }
  }

  getContractFooter(): void {
    if (this.userData!.country === 'AT' || this.userData!.preferredLanguage === 'austria') {
      const myFirstDirector = this.myDirectManager ? this.myDirectManager : undefined;

      if (!myFirstDirector) {
        this.contractFooter = `
            <p><strong>Antragsabteilung Österreich:</strong></p>
            <p>+49 6131 58388-54<br><a href="mailto:antrag-at@efs-ag.de">antrag-at@efs-ag.de</a></p>`;

          this.securityFooter = `
            <p><strong>Wertpapierabteilung:</strong></p>
            <p>+49 6131 58388-54<br><a href="mailto:wertpapier-antraege@efs-ag.de">wertpapier-antraege@efs-ag.de</a></p>
            <p><a href="https://files.efs-ag.services/EFS-Wertpapierabteilung.vcf">Telefonbuchkontakt</a></p>
          `;
      } else {
        // Show details for myFirstDirector
        const matchingContractMailBox = directionsAT.find(director => director.cn === myFirstDirector.cn);
        if (matchingContractMailBox) {
          // Show details for matchingContractMailBox
          this.contractFooter = `
            <p><strong>Direktion ${myFirstDirector.displayName}</strong></p>
            <p><a href="mailto:${matchingContractMailBox.directorContractMailBox}">${matchingContractMailBox.directorContractMailBox}</a></p>
          `;

          this.securityFooter = `
            <p><strong>Wertpapierabteilung:</strong></p>
            <p>+49 6131 58388-54<br><a href="mailto:wertpapier-antraege@efs-ag.de">wertpapier-antraege@efs-ag.de</a></p>
            <p><a href="https://files.efs-ag.services/EFS-Wertpapierabteilung.vcf">Telefonbuchkontakt</a></p>
          `;

        } else {
          this.contractFooter = `
            <p><strong>Antragsabteilung Österreich:</strong></p>
            <p>+49 6131 58388-54<br><a href="mailto:antrag-at@efs-ag.de">antrag-at@efs-ag.de</a></p>`;

          this.securityFooter = `
            <p><strong>Wertpapierabteilung:</strong></p>
            <p>+49 6131 58388-54<br><a href="mailto:wertpapier-antraege@efs-ag.de">wertpapier-antraege@efs-ag.de</a></p>
            <p><a href="https://files.efs-ag.services/EFS-Wertpapierabteilung.vcf">Telefonbuchkontakt</a></p>
          `;
        }
      }
    }

    if (this.userData!.country === 'DE' || this.userData!.preferredLanguage === 'german') {
      const myFirstDirector = this.myDirectManager ? this.myDirectManager : undefined;

      if (!myFirstDirector) {
        this.contractFooter = `
            <p><strong>Antragsabteilung Deutschland:</strong></p>
            <p>+49 6131 5838-50<br><a href="mailto:antrag@efs-ag.de">antrag@efs-ag.de</a></p>
            <p><a href="https://files.efs-ag.services/EFS-Antragsabteilung-DE.vcf">Telefonbuchkontakt</a></p>
          `;
      } else {
        // Show details for myFirstDirector
        const matchingContractMailBox = directionsAT.find(director => director.cn === myFirstDirector.cn);
        if (matchingContractMailBox) {
          // Show details for matchingContractMailBox
          this.contractFooter = `
            <strong>Direktion ${myFirstDirector.displayName}</strong><br>
            <p><a href="mailto:${matchingContractMailBox.directorContractMailBox}">${matchingContractMailBox.directorContractMailBox}</a></p>
          `;
        } else {
          this.contractFooter = `
            <p><strong>Antragsabteilung Deutschland:</strong></p>
            <p>+49 6131 5838-50<br><a href="mailto:antrag@efs-ag.de">antrag@efs-ag.de</a></p>
            <p><a href="https://files.efs-ag.services/EFS-Antragsabteilung-DE.vcf">Telefonbuchkontakt</a></p>
          `;
        }
      }
    }
  }
}
